module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_skeletal-510b3bed16d662be05e4c67f3d97aeb2.jpg";